import React from "react";

export const MostlyCloudyDayIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="28" fillRule="nonzero" fill="#3F4447">
                <g transform="translate(2.000000, 10.000000)">
                    <path
                        d="M56.85 12.205l.585 2.75a1.55 1.55 0 103.03-.644l-.584-2.75a1.55 1.55 0 00-3.03.644zM67.821 13.279l-1.531 2.358a1.55 1.55 0 002.598 1.688l1.532-2.358a1.55 1.55 0 10-2.599-1.688zM74.855 22.127l-2.75.584a1.55 1.55 0 10.644 3.031l2.75-.584a1.55 1.55 0 00-.644-3.031zM56.553 23.329a5.164 5.164 0 117.808 6.538 1.55 1.55 0 102.013 2.357 8.263 8.263 0 10-12.495-10.46 1.55 1.55 0 002.674 1.565z"
                        fill="#FCBA38"
                    />
                    <path
                        d="M64.915 52.68c4.968 0 8.986-3.954 8.986-8.82 0-4.867-4.017-8.822-8.986-8.822a9.16 9.16 0 00-2.332.3 1.55 1.55 0 01-1.93-1.292c-.586-4.351-4.383-7.65-8.907-7.65-.105 0-.21.001-.316.005a1.55 1.55 0 01-1.567-1.22c-1.477-6.801-7.62-11.75-14.797-11.75-7.777 0-14.26 5.792-15.051 13.327a1.55 1.55 0 01-1.457 1.385c-6.604.36-11.793 5.74-11.793 12.26 0 6.775 5.59 12.278 12.498 12.278h45.652zm0-20.74C71.584 31.94 77 37.27 77 43.86c0 6.588-5.416 11.92-12.085 11.92H19.263c-8.608 0-15.597-6.88-15.597-15.378 0-7.749 5.827-14.196 13.446-15.232 1.512-8.49 9.034-14.837 17.954-14.837 8.209 0 15.306 5.391 17.521 12.992 5.143.35 9.46 3.889 10.808 8.708a12.349 12.349 0 011.52-.094z"
                        fill="#717277"
                    />
                </g>
            </g>
        </g>
    </svg>
);
